import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signInStart, signInSuccess, signInFailure } from "../redux/user/userSlice.js";
import OAuth from "../components/OAuth.jsx";

const SignIn = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({});

    const { loading, error } = useSelector((state) => state.user);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            dispatch(signInStart)

            const res = await fetch("http://localhost:8080/api/v1/auth/signin", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            const data = await res.json();

            if (data.success === false) {
                dispatch(signInFailure(data.message))
                return;
            }

            dispatch(signInSuccess(data));
            navigate("/");
        } catch (error) {
            dispatch(signInFailure(error.message));
        }

    };


    return (
        <div className="p-3 max-w-lg mx-auto h-[550px] mb-16 font-primary">
            <div className="absolute top-0 left-[55%] overlay-glow"></div>
            <h1 className="text-4xl text-light text-center font-bold my-7">Sign In</h1>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">

                <div className="flex flex-col mb-2">
                    <label for="email" class="text-gray-200 pb-1">Email</label>
                    <input required="" type="email" id="email" placeholder="john@doe.com" class="border rounded-lg outline-none bg-transparent text-gray-400 p-3" onChange={handleChange} />
                </div>

                <div className="flex flex-col">
                    <label for="password" class="text-gray-200 pb-1">Password</label>
                    <input required="" type="password" id="password" placeholder="********" class="border rounded-lg outline-none bg-transparent text-gray-400 p-3" onChange={handleChange} />
                </div>

                <div className="absolute top-0 right-[90%] overlay-glow2"></div>


                <button type="submit" class="p-3 uppercase hover:opacity-95 disabled:opacity-80 primary-color w-full mt-8 text-white rounded-lg">
                    {loading ? 'Loading...' : 'Sign In'}
                </button>
                {/* sign in with Google */}
                <OAuth />
            </form>

            <div className="flex gap-2 mt-5">
                <p className="text-light">Don&apos;t have an account yet?</p>
                <Link to={"/sign-up"}>
                    <span className="text-blue-700 pl-2 font-semibold">Sign Up</span>
                </Link>
            </div>

            {error && <p className="text-red-500 mt-5">{error}</p>}
        </div>
    );
};

export default SignIn;